'use client';

import pom from '@/utils/pom';
import { applyDataTestId } from '@/utils/testUtils';
import { MenuItemProps } from '@/types/menus';
import MenuItemContent from '@/components/menu/menuItemContent';
import ReorderCardContent from '@/components/reorders/reorderCardContent';
import { addItemsToCart, mapItemToCartEntry } from '@/utils/cart';
import { LocalStorageKey, SessionStorageKey } from '@/utils/storageKeys';
import { toastService } from '@/utils/toastService';
import useMediaQuery from '@/utils/useMediaQuery';
import { getFromSessionStorage } from '@/utils/sessionStorageUtils';
import { CartItemType } from '@/constants/enum';

interface ReorderMenuItemProps extends MenuItemProps {
  readonly merchantColor: string;
}

const ReorderMenuItem = ({
  categoryId,
  item,
  itemTemplate,
  merchantName,
  merchantColor,
  cartItem,
}: ReorderMenuItemProps) => {
  const isMobileScreen = useMediaQuery('(max-width: 640px)');

  const addItemToCart = () => {
    if (!cartItem) {
      return;
    }

    const sessionDayPartMenu = getFromSessionStorage<{menuId?: string;}>(SessionStorageKey.DAYPART_MENU, {});
    const menuId = sessionDayPartMenu?.menuId;

    // no matter how many times the item was ordered before, here we want to add 1 to the cart
    const newCartItem = { ...cartItem, quantity: 1 };
        
    const cartItemToAdd = mapItemToCartEntry(newCartItem, CartItemType.RESTAURANT,  {
      menuId,
    });
    addItemsToCart(LocalStorageKey.RESTAURANT_CART, [cartItemToAdd]);

    toastService.notifyItemReorderedAddedToCart(isMobileScreen, item.name);
  };

  return (
    <button
      id={`reorder-item-card-${item.id}-${categoryId}`}
      className="block h-full w-full text-left"
      data-testid={applyDataTestId(pom.orders.reorderButton)}
      onClick={addItemToCart}
    >
      <MenuItemContent
        item={item}
        merchantName={merchantName}
        itemTemplate={itemTemplate}
        cardChildren={<ReorderCardContent merchantColor={merchantColor} />}
      />
    </button>
  );
};

export default ReorderMenuItem;
